import React from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import styled from 'styled-components';

import { Loader } from '../components/Loader';
import { Error } from '../components/Error';

import CarPartsList from './CarPartsList';

const NoResults = styled.div`
  align-items: center;
  display: flex;
  font-size: 1.25rem;
  font-weight: 700;
  justify-content: center;
  height: 200px;
`;

const GET_PARTS = gql`
  query getParts(
    $regNumber: String
    $search: String
    $brandId: Int
    $modelId: Int
    $variantId: Int
    $partGroupIds: [Int]
    $partTypeIds: [Int]
    $storageNumber: String
    $orderBy: String
    $limit: Int
    $offset: Int
  ) {
    carParts: getParts(
      regNumber: $regNumber
      search: $search
      BilNr: $brandId
      ModellNr: $modelId
      Bilkod: $variantId
      DelgruppId: $partGroupIds
      Delkod: $partTypeIds
      Lagernummer: $storageNumber
      orderBy: $orderBy
      limit: $limit
      offset: $offset
    ) {
      total
      limit
      offset
      items {
        id: Indx
        name: displayName
        stockNumber: Lagernummer
        quality: Kvalitet
        price: Pris
        images: Bilder
        country: Land
      }
    }
  }
`;

export default function CarParts({
  regNumber,
  search,
  brandId,
  modelId,
  variantId,
  partGroupIds,
  partTypeIds,
  storageNumber,
  orderBy
}) {
  console.log("OrderBy-arg, clientside", orderBy);
  return (
    <Query
      query={GET_PARTS}
      variables={{
        regNumber: regNumber,
        search: search,
        brandId: brandId,
        modelId: modelId,
        variantId: variantId,
        partGroupIds: partGroupIds,
        partTypeIds: partTypeIds,
        storageNumber: storageNumber,
        orderBy: orderBy,
        limit: 20,
        offset: 0
      }}
      notifyOnNetworkStatusChange={true}
    >
      {({ loading, error, data, fetchMore }) => {
        if (loading && !data.carParts) {
          return <Loader />;
        }

        if (error) {
          return <Error error={error} />;
        }

        if (!data.carParts.items || data.carParts.items.length === 0) {
          return <NoResults>Fant ingen deler!</NoResults>;
        }

        return (
          <CarPartsList
            carParts={data.carParts.items}
            total={data.carParts.total}
            hasMore={data.carParts.items.length < data.carParts.total}
            loading={loading}
            onLoadMore={() =>
              fetchMore({
                variables: {
                  offset: data.carParts.items.length
                },
                updateQuery: (prev, { fetchMoreResult }) => {
                  if (!fetchMoreResult) return prev;

                  let mergedResult = Object.assign({}, prev, fetchMoreResult);

                  mergedResult.carParts.items = [
                    ...prev.carParts.items,
                    ...fetchMoreResult.carParts.items
                  ];

                  return mergedResult;
                }
              })
            }
          />
        );
      }}
    </Query>
  );
}

CarParts.propTypes = {
  regNumber: PropTypes.string,
  search: PropTypes.string,
  brandId: PropTypes.number,
  modelId: PropTypes.number,
  variantId: PropTypes.number,
  partGroupIds: PropTypes.arrayOf(PropTypes.number),
  partTypeIds: PropTypes.arrayOf(PropTypes.number)
};

CarParts.defaultProps = {
  regNumber: null,
  search: null,
  brandId: null,
  modelId: null,
  variantId: null,
  partGroupIds: null,
  partTypeIds: null
};
